export default class ExtraListenerError extends Error {
  private reason?: string;

  constructor(message = 'Extra listener for event is not allowed!', reason?: string) {
    super(message);
    this.name = 'ExtraListenerError';
    this.reason = reason;
  }
}
